<!-- Faixa do grupo na barra superior: o gatilho do seletor grande (busca por empresa, grupo ou CNPJ).
     Com marca do grupo (cor), proposta A de 26/10/2026: logo solto na faixa e a empresa em texto, sem
     caixa. Logo, grupo e empresa são UM botão: clicar em qualquer parte troca de empresa (só o nome era
     alvo pequeno demais). Sem marca, o gatilho de antes: a caixa appCompanyTrigger (logo, divisor,
     empresa e grupo), a mesma da prévia na tela Identidade visual. -->
@let brand = identity();
@if (brand?.color) {
  <button type="button" class="company-switch" [disabled]="companies.length <= 1" (click)="openSwitcher()"
    [attr.aria-label]="currentLabel ? 'Trocar de empresa, atual ' + currentLabel : 'Selecione a empresa'">
    @if (brandLogo || brand?.groupName) {
      <span class="company-brand-mark">
        <!-- Logo que não carrega some, como na Início; o botão fica. -->
        @if (brandLogo; as logo) {
          <img class="company-brand-logo" [class.company-brand-logo--icon]="!brand?.logoIsWide" [src]="logo"
            [alt]="brand?.logoIsWide ? brand?.groupName ?? '' : ''" (error)="failedLogoUrl = logo" />
        }
        <!-- Só o logo horizontal carregado já diz o grupo. Com ícone, sem logo ou com logo que falhou, o
             nome vai ao lado. No celular ele fica só para leitor de tela (a faixa não tem espaço). -->
        @if (!(brandLogo && brand?.logoIsWide) && brand?.groupName) {
          <span class="company-brand-group">{{ brand?.groupName }}</span>
        }
      </span>
    }
    <span class="company-switch-name">{{ currentLabel || 'Selecione a empresa' }}</span>
    @if (companies.length > 1) {
      <i class="ti ti-chevron-down company-switch-caret" aria-hidden="true"></i>
    }
  </button>
  <span class="company-brand-divider d-none d-md-block" aria-hidden="true"></span>
} @else {
  <button type="button" appCompanyTrigger [disabled]="companies.length <= 1" (click)="openSwitcher()"
    [attr.aria-label]="'Empresa ativa: ' + (currentLabel || 'nenhuma') + '. Trocar de empresa'"
    [logoUrl]="brand?.logoUrl ?? null" [iconUrl]="avatarUrl" [markName]="markName"
    [companyName]="currentLabel || 'Selecione a empresa'" [groupName]="brand?.groupName ?? null"
    [caret]="companies.length > 1"></button>
}
